{
  "list": {
    "title": "Սարքեր",
    "addNew": "+ Նոր սարք",
    "confirm": {
      "delete": "Ջնջե՞լ {{name}} (SN: {{serial}}) սարքը: Ներկայության պատմությունը կպահպանվի, բայց տերմինալն այլևս չի ճանաչվի:"
    },
    "pendingActivation_one": "{{count}} սարք սպասում է ակտիվացման:",
    "pendingActivation_other": "{{count}} սարք սպասում է ակտիվացման:",
    "failedToLoad": "Չհաջողվեց բեռնել տվյալները: Խնդրում ենք կրկին փորձել:",
    "empty": "Դեռ սարքեր չկան: Ավելացնելու համար սեղմեք + Նոր սարք:",
    "activate": "Ակտիվացնել",
    "columns": {
      "serial": "Սերիական համար",
      "name": "Անուն",
      "description": "Նկարագրություն",
      "status": "Կարգավիճակ",
      "users": "Օգտատերեր",
      "logs": "Տեղեկամատյան",
      "lastSeen": "Վերջին ակտիվություն",
      "actions": "Գործողություններ"
    },
    "badges": {
      "pending": "Սպասվող",
      "pendingCommands_one": "{{count}} հրաման սպասում է առաքման",
      "pendingCommands_other": "{{count}} հրաման սպասում է առաքման"
    },
    "aria": {
      "deactivate": "Ապաակտիվացնել սարքը",
      "activate": "Ակտիվացնել սարքը",
      "notManaged": "Դուք չեք կառավարում այս սարքը"
    }
  },
  "detail": {
    "accessDenied": "Մուտքն արգելված է",
    "accessDeniedHint": "Դուք թույլտվություն չունեք դիտելու այս սարքը:",
    "backToDevices": "Վերադառնալ սարքեր",
    "notFound": "Սարքը չի գտնվել",
    "failedToLoad": "Չհաջողվեց բեռնել սարքը: Խնդրում ենք կրկին փորձել:",
    "breadcrumb": "Սարքեր",
    "importAll": "Ներմուծել բոլորին տերմինալից",
    "importing": "Ներմուծվում է…",
    "exportAll": "Արտահանել բոլորին տերմինալ",
    "exporting": "Արտահանվում է…",
    "pushSettings": "Ուղարկել բոլոր կարգավորումները հիմա",
    "pushingSettings": "Ուղարկվում է…",
    "pushSettingsSuccess_one": "{{count}} հրաման հերթագրված է:",
    "pushSettingsSuccess_other": "{{count}} հրաման հերթագրված է:",
    "pendingCommands_one": "{{count}} հրաման սպասում է տերմինալ առաքման",
    "pendingCommands_other": "{{count}} հրաման սպասում է տերմինալ առաքման",
    "addExisting": "+ Ավելացնել առկա",
    "addNew": "+ Նոր աշխատակից",
    "editDevice": "Խմբագրել սարքը",
    "clearHistory": "Մաքրել պատմությունը տերմինալում",
    "clearing": "Մաքրվում է…",
    "ownerLabel": "Սեփականատեր՝",
    "lastSeenLabel": "Վերջին ակտիվություն՝",
    "employees": "Աշխատակիցներ",
    "searchPlaceholder": "Որոնել...",
    "failedToLoadEmployees": "Չհաջողվեց բեռնել աշխատակիցներին: Խնդրում ենք կրկին փորձել:",
    "noEmployeesSearch": "Որոնմանը համապատասխան աշխատակից չի գտնվել:",
    "noEmployeesEmpty": "Այս սարքում դեռ գրանցված աշխատակիցներ չկան:",
    "columns": {
      "deviceUserId": "Սարքի օգտատիրոջ ID",
      "name": "Անուն",
      "role": "Դեր",
      "card": "Քարտ",
      "status": "Կարգավիճակ",
      "lastSynced": "Վերջին համաժամացում",
      "lastSeenHere": "Վերջին ակտիվություն այստեղ",
      "syncState": "Համաժամացման կարգավիճակ"
    },
    "syncBadges": {
      "synced": "Համաժամացված",
      "sent": "Ուղարկված",
      "pending": "Սպասվող",
      "removing": "Հեռացվում է",
      "removed": "Հեռացված"
    },
    "actions": {
      "edit": "Խմբագրել",
      "export": "Արտահանել",
      "unenroll": "Հետ կանչել"
    },
    "confirm": {
      "importAll": "Ներմուծե՞լ բոլոր աշխատակիցներին տերմինալից: Համընկնող գրառումները կվերաձայնվեն:",
      "exportAll": "Արտահանե՞լ բոլոր աշխատակիցներին տերմինալ: Բոլոր ակտիվ աշխատակիցները կուղարկվեն սարք:",
      "clearHistory": "Մաքրե՞լ տերմինալի բոլոր գրանցումների պատմությունը: Այն չի կարող վերականգնվել:",
      "unenroll": "Հեռացնե՞լ այս աշխատակցին սարքից:",
      "importQueue": "Հերթագրե՞լ DATA QUERY հրամանը՝ տերմինալից բոլոր օգտատերերին ներբեռնելու համար:",
      "exportAllDetail": "Ուղարկե՞լ բոլոր գրանցված աշխատակիցներին (USERINFO + լուսանկարներ + կենսաչափական ձևանմուշներ) այս տերմինալ:",
      "clearHistorySwipes": "Սա կջնջի «{{name}}» տերմինալում պահված բոլոր գրանցումների պատմությունը:\n\nՀավելվածի տեղական գրառումները կպահպանվեն:\n\nՇարունակե՞լ:",
      "clearHistoryPhotos": "Ջնջե՞լ նաև ներկայության լուսանկարները տերմինալից:\n\nՍեղմեք OK՝ նաև լուսանկարները ջնջելու, Չեղարկել՝ պահելու համար:",
      "unenrollDetail": "Հետ կանչե՞լ «{{name}}»-ին (PIN {{pin}}) այս սարքից:\n\nԱշխատակիցը և ներկայության պատմությունը ջնջված չեն լինի: DATA DELETE USERINFO հրամանը կհերթագրվի:"
    },
    "unenrollFailed": "Հետ կանչելը ձախողվեց: Կրկին փորձեք:",
    "importQueued": "Հերթագրված է {{count}} հրաման(ներ): {{message}}",
    "importFailed": "Ներմուծումը ձախողվեց: Ստուգեք, որ տերմինալն առցանց է:",
    "exportQueued": "Արտահանումը հերթագրված է {{employees}} աշխատակցի(-ների) համար:\n• {{userinfo}} օգտատիրոջ գրառում\n• {{userpic}} լուսանկար\n• {{biometric}} կենսաչափական ձևանմուշ\n\n{{message}}",
    "exportFailed": "Արտահանումը ձախողվեց:",
    "clearHistoryFailed": "Պատմությունը մաքրելը ձախողվեց:",
    "pushSettingsFailed": "Կարգավորումների ուղարկումը ձախողվեց:",
    "exportOneQueued": "Հերթագրված է {{name}}-ի (PIN {{pin}}) համար {{devices}} սարք(ի) վրա:",
    "titlePullUsers": "Ներբեռնել օգտատերերին, լուսանկարները և կենսաչափական ձևանմուշները այս տերմինալից",
    "titleRestoreDB": "Վերականգնել տեղական ԲՏ-ի և MinIO-ի բովանդակությունը այս տերմինալ",
    "titlePushSettings": "Ուղարկել բոլոր պահված ապարատային կարգավորումները տերմինալ",
    "titleWipeHistory": "Ջնջել տերմինալում պահված ներկայության պատմությունը: Տեղական ԲՏ-ն կպահպանվի:",
    "roleFallbackUser": "Օգտատեր",
    "aria": {
      "searchEmployees": "Որոնել աշխատակիցներ",
      "loadingEmployees": "Բեռնվում են աշխատակիցները..."
    }
  },
  "editDialog": {
    "titleNew": "Նոր սարք",
    "titleEdit": "Խմբագրել սարքը — {{name}}",
    "serialLabel": "Սերիական համար",
    "serialHint": "Կապված է ֆիզիկական տերմինալին: Հնարավոր չէ փոխել:",
    "nameLabel": "Անուն",
    "descriptionLabel": "Նկարագրություն (կամընտիր)",
    "descriptionPlaceholder": "Տերմինալի գտնվելու վայրը կամ նշումներ…",
    "ownerLabel": "Սեփականատեր",
    "activeLabel": "Ակտիվ",
    "saveFailed": "Չհաջողվեց պահպանել",
    "hardware": {
      "title": "Տերմինալի կարգավորումներ",
      "tzAdj": "Ժամային գոտու տեղաշարժ (րոպե UTC-ից)",
      "verifyMode": "Ստուգման ռեժիմ",
      "verifyModeOptions": {
        "0": "Ցանկացած եղանակ (լռելյայն)",
        "1": "Միայն մատնահետք",
        "4": "Միայն քարտ",
        "6": "Մատնահետք կամ քարտ",
        "15": "Միայն դեմք"
      },
      "verifyModeHint": "Գործում է այս տերմինալի բոլոր աշխատակիցների համար. ռեժիմը փոխելիս նրանց տվյալները նորից ուղարկվում են սարքին։",
      "lockOn": "Կողպեքի ռելեի տևողություն (վ)",
      "volume": "Բարձրախոսի ձայն",
      "idlePower": "Անգործության անջատում (րոպ, 0 = անջատ)",
      "idleMinute": "Քնի ռեժիմի ժամաչափ (րոպ, 0 = անջատ)",
      "lockFun": "Դռան կողպեքի ֆունկցիա",
      "punchAlarm": "Նշման ազդանշան (րոպ)",
      "mustEnroll": "Միայն գրանցված օգտատերեր"
    }
  },
  "enrollDialog": {
    "title": "Ավելացնել առկա աշխատակիցներ",
    "searchPlaceholder": "Որոնել ըստ անունի կամ PIN-ի...",
    "allEnrolled": "Բոլոր աշխատակիցներն արդեն գրանցված են այս սարքում:",
    "noResults": "Որոնմանը համապատասխան աշխատակից չի գտնվել:",
    "noneSelected": "Ոչինչ չի ընտրված",
    "countSelected_one": "Ընտրված՝ {{count}}",
    "countSelected_other": "Ընտրված՝ {{count}}",
    "enrolling": "Գրանցվում է…",
    "enroll_one": "Գրանցել {{count}}",
    "enroll_other": "Գրանցել {{count}}",
    "columns": {
      "pin": "PIN",
      "name": "Անուն"
    },
    "enrollFailed": "Գրանցումը ձախողվեց",
    "enrollSuccess_one": "Գրանցված է {{count}} աշխատակից: Տերմինալ ուղարկված {{queued}} հրաման:",
    "enrollSuccess_other": "Գրանցված է {{count}} աշխատակից: Տերմինալ ուղարկված {{queued}} հրաման(ներ):"
  },
  "selectTerminalsDialog": {
    "title": "Ընտրել տերմինալներ",
    "subtitle": "Ընտրեք տերմինալները",
    "confirm": "Ուղարկել",
    "importConfirm": "Ներմուծել",
    "noActiveTerminals": "Ակտիվ տերմինալ չկա",
    "selectAll": "Ընտրել բոլոր",
    "deselectAll": "Հեռացնել ընտրությունը",
    "noneSelected": "Ոչինչ չի ընտրված",
    "countSelected_one": "Ընտրված՝ {{count}}",
    "countSelected_other": "Ընտրված՝ {{count}}"
  },
  "terminalUsers": {
    "title": "Աշխատակիցներ",
    "importAll": "Ներմուծել բոլորին տերմինալից",
    "exportAll": "Արտահանել բոլորին տերմինալ",
    "addNew": "+ Նոր աշխատակից",
    "searchPlaceholder": "Որոնել ըստ անունի կամ PIN-ի…",
    "filters": {
      "status": "Կարգավիճակ",
      "statusAll": "Բոլոր",
      "statusActive": "Ակտիվ",
      "statusInactive": "Ոչ ակտիվ",
      "role": "Դեր",
      "roleUser": "Օգտատեր",
      "roleAdmin": "Ադմին",
      "roleSuperAdmin": "Գլխավոր ադմին",
      "device": "Սարք",
      "hasDevice": "Ունի սարք",
      "noDevice": "Չունի սարք"
    },
    "bulkActions": {
      "selected_one": "{{count}} ընտրված",
      "selected_other": "{{count}} ընտրված",
      "deselectAll": "Հեռացնել ընտրությունը",
      "pushToTerminal": "Ուղարկել տերմինալ",
      "pushing": "Ուղարկվում է…",
      "activate": "Ակտիվացնել",
      "activating": "Ակտիվացվում է…",
      "deactivate": "Ապաակտիվացնել",
      "deactivating": "Ապաակտիվացվում է…",
      "delete": "Ջնջել",
      "deleting": "Ջնջվում է…"
    },
    "empty": {
      "noEmployees": "Դեռ աշխատակիցներ չկան",
      "noResults": "Ֆիլտրերին համապատասխան արդյունք չկա: Փորձեք փոխել որոնումը կամ ֆիլտրերը:",
      "noEmployeesHint": "Ձեռքով ավելացնելու համար սեղմեք + Նոր աշխատակից, կամ ներմուծեք տերմինալից:",
      "clearFilters": "Մաքրել ֆիլտրերը"
    },
    "failedToLoad": "Չհաջողվեց բեռնել աշխատակիցներին",
    "failedToLoadHint": "Ստուգեք կապը և կրկին փորձեք:",
    "columns": {
      "employee": "Աշխատակից",
      "role": "Դեր",
      "pay": "Վճար",
      "devices": "Սարքեր",
      "status": "Կարգավիճակ",
      "biometrics": "Կենսաչափություն"
    },
    "privilegeLabels": {
      "superAdmin": "Գլխավոր ադմին",
      "admin": "Ադմին",
      "enroller": "Գրանցող",
      "user": "Օգտատեր"
    },
    "confirm": {
      "bulkDelete": "Ջնջե՞լ {{count}} աշխատակից(ներ)ին տերմինալից: Այն չի կարող վերականգնվել:",
      "deleteOne": "Ջնջե՞լ «{{name}}»-ին (PIN {{pin}}) տերմինալից:"
    },
    "titlePullUsers": "Ներբեռնել օգտատերերին, լուսանկարները և կենսաչափական ձևանմուշները տերմինալից",
    "titleRestoreDB": "Վերականգնել տեղական ԲՏ-ի և MinIO-ի բովանդակությունը տերմինալ",
    "aria": {
      "searchEmployees": "Որոնել աշխատակիցներ",
      "loadingEmployees": "Բեռնվում են աշխատակիցները…",
      "pushSelected": "Ուղարկել ընտրված աշխատակիցներին տերմինալ",
      "activateSelected": "Ակտիվացնել ընտրված աշխատակիցներին",
      "deactivateSelected": "Ապաակտիվացնել ընտրված աշխատակիցներին",
      "deleteSelected": "Ջնջել ընտրված աշխատակիցներին",
      "bulkActions": "Զանգվածային գործողություններ",
      "filterEmployees": "Ֆիլտրել աշխատակիցներ",
      "editEmployee": "Խմբագրել աշխատակցին",
      "pushToTerminal": "Ուղարկել տերմինալ",
      "deleteEmployee": "Ջնջել աշխատակցին"
    },
    "toasts": {
      "pushed_one": "{{count}} աշխատակից ուղարկված տերմինալ:",
      "pushed_other": "{{count}} աշխատակից ուղարկված տերմինալ:",
      "activated_one": "{{count}} աշխատակից ակտիվացված:",
      "activated_other": "{{count}} աշխատակից ակտիվացված:",
      "deactivated_one": "{{count}} աշխատակից ապաակտիվացված:",
      "deactivated_other": "{{count}} աշխատակից ապաակտիվացված:",
      "deleted_one": "{{count}} աշխատակից ջնջված:",
      "deleted_other": "{{count}} աշխատակից ջնջված:",
      "deleteFailed": "Ջնջումը ձախողվեց: Կրկին փորձեք:",
      "exportFailed": "Արտահանումը ձախողվեց: Կրկին փորձեք:",
      "importFailed": "Ներմուծումը ձախողվեց: Կրկին փորձեք:",
      "someExportsFailed": "Արտահանումը մասամբ ձախողվեց:",
      "importQueued": "Հերթագրված է {{count}} հրաման(ներ) {{devices}} սարքի(-ների) վրա:",
      "exportAllQueued": "Արտահանումը հերթագրված է. {{employees}} աշխատակից {{devices}} սարքի(-ների) վրա:",
      "exportOneQueued": "Հերթագրված է {{name}}-ի համար {{devices}} սարքի(-ների) վրա:"
    },
    "biometricKinds": {
      "face": "Դեմք",
      "fp": "Մատնահետք",
      "palm": "Ափ"
    }
  }
}
